<script setup>
import AvatarEyes from "./avatar/AvatarEyes";
import AvatarMouth from "./avatar/AvatarMouth";
import AvatarHairBack from "./avatar/AvatarHairBack";
import AvatarHairFront from "./avatar/AvatarHairFront";
import AvatarAccessories from "./avatar/AvatarAccessories";
import AvatarEyebrows from "./avatar/AvatarEyebrows";
import AvatarFacialHair from "./avatar/AvatarFacialHair";
import AvatarGlasses from "./avatar/AvatarGlasses";
import AvatarClothes from "./avatar/AvatarClothes";
import AvatarTattoos from "./avatar/AvatarTattoos";
import AvatarComponent from "./AvatarComponent.vue";
import {onMounted, ref} from "vue";

import avatarBackgrounds from "../../../profile/config/avatar/backgrounds";

const skins = ref([]);
const eyes = ref([]);
const eyebrows = ref([]);
const mouths = ref([]);
const hairstyles = ref([]);
const haircolors = ref([]);
const facialhairs = ref([]);
const clothes = ref([]);
const fabriccolors = ref([]);
const backgrounds = ref([]);
const glasses = ref([]);
const glassopacities = ref([]);
const tattoos = ref([]);
const accessories = ref([]);
const activeSkin = ref("");
const activeEyes = ref("");
const activeEyebrows = ref("");
const activeMouth = ref("");
const activeHairstyle = ref("");
const activeHaircolor = ref("");
const activeFacialhair = ref("");
const activeClothes = ref("");
const activeFabriccolor = ref("");
const activeBackground = ref("");
const activeGlasses = ref("");
const activeGlassopacity = ref(0);
const activeTatttoos = ref("");
const activeAccessories = ref("");
const activeMenu = ref("");
const saving = ref(false);

const rewards = ref([]);

const avatarComponent = ref(null)

const props = defineProps({
    inGame: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update']);

onMounted(() => {
    getAvatarData();
    getUserRewards();
})

function mainMenu() {
    this.activeMenu = '';
}

function updateAvatar(type, value) {
    switch (type) {
        case 'skin':
            activeSkin.value = value;
            break;
        case 'eyes':
            activeEyes.value = value;
            break;
        case 'eyebrows':
            activeEyebrows.value = value;
            break;
        case 'mouth':
            activeMouth.value = value;
            break;
        case 'hairstyle':
            activeHairstyle.value = value;
            break;
        case 'haircolor':
            activeHaircolor.value = value;
            break;
        case 'facialhair':
            activeFacialhair.value = value;
            break;
        case 'clothes':
            activeClothes.value = value;
            break;
        case 'fabriccolor':
            activeFabriccolor.value = value;
            break;
        case 'background':
            activeBackground.value = value;
            break;
        case 'glasses':
            activeGlasses.value = value;
            break;
        case 'glassopacity':
            activeGlassopacity.value = value;
            break;
        case 'tattoos':
            activeTatttoos.value = value;
            break;
        case 'accessories':
            activeAccessories.value = value;
            break;
    }

    avatarComponent.value.updateAvatar(type, value);
}

function hairColorFront(color) {
    return color.split("_")[0];
}

function hairColorBack(color) {
    return color.split("_")[1];
}

function hairColorFacial(color) {
    return color.split("_")[2];
}

function save() {
    saving.value = true;
    const avatarJson = JSON.stringify({
        skin: activeSkin.value,
        eyes: activeEyes.value,
        eyebrows: activeEyebrows.value,
        mouth: activeMouth.value,
        hairstyle: activeHairstyle.value,
        haircolor: activeHaircolor.value,
        facialhair: activeFacialhair.value,
        clothes: activeClothes.value,
        fabriccolor: activeFabriccolor.value,
        background: activeBackground.value,
        glasses: activeGlasses.value,
        glassopacity: activeGlassopacity.value,
        tattoos: activeTatttoos.value,
        accessories: activeAccessories.value
    });

    if(props.inGame) {
        emit('update', avatarJson);
        setTimeout(() => {
            saving.value = false;
        }, 250);
    } else {
        axios.post('/profile/avatar', {
            avatar: avatarJson
        }).then(() => {
            avatarComponent.value.setAvatarData(JSON.parse(avatarJson));
            avatarComponent.value.saveAvatar();
            saving.value = false;
        });
    }
}

function getAvatarData() {
    backgrounds.value = avatarBackgrounds();
    axios.get('/profile/avatar-data').then(response => {
        if(response.data) {
            skins.value = response.data.skins;
            eyes.value = response.data.eyes;
            eyebrows.value = response.data.eyebrows;
            mouths.value = response.data.mouths;
            hairstyles.value = response.data.hairstyles;
            haircolors.value = response.data.haircolors;
            facialhairs.value = response.data.facialhairs;
            clothes.value = response.data.clothes;
            fabriccolors.value = response.data.fabriccolors;
            glasses.value = response.data.glasses;
            glassopacities.value = response.data.glassopacities;
            tattoos.value = response.data.tattoos;
            accessories.value = response.data.accessories;
        }
    });
}

function setDefaultData(data) {
    for (const [key, value] of Object.entries(data)) {
        updateAvatar(key, value);
    }
}

function getUserRewards() {
    let userRewards = {};

    axios.get('/api/profile/rewards').then(response => {
        if(response.data) {
            response.data.rewards.forEach(reward => {
                const rewardData = JSON.parse(reward.data);
                for (let key in rewardData) {
                    if (rewardData.hasOwnProperty(key)) {
                        if (Array.isArray(rewardData[key])) {
                            userRewards[key] = rewardData[key];
                        }
                    }
                }
            });

            rewards.value = userRewards;
        }
    });

}

function hasPart(type, part) {
    if(part.default) {
        return true;
    } else {
        return rewards.value[type]?.includes(part.name);
    }
}
</script>

<template>
    <div class="editor game-menu__item-card__row">
        <div
            class="avatar row"
            id="avatar"
        >
            <div class="avatar__menu col-12 col-lg-6">
                <div
                    v-if="['appearance', 'background', 'style'].includes(activeMenu)"
                    class="avatar__menu-breadcrumbs"
                    @click="activeMenu = ''"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                    </svg> {{ __('account.profile.avatar.title') }}
                </div>
                <div
                    v-if="['skins', 'eyes', 'eyebrows', 'mouth', 'hair', 'tattoos'].includes(activeMenu)"
                    class="avatar__menu-breadcrumbs"
                    @click="activeMenu = 'appearance'"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                    </svg> {{ __('account.profile.avatar.appearance') }}
                </div>
                <div
                    v-if="['top', 'glasses', 'accessories'].includes(activeMenu)"
                    class="avatar__menu-breadcrumbs"
                    @click="activeMenu = 'style'"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                    </svg> {{ __('account.profile.avatar.style') }}
                </div>
                <div class="avatar__menu-list" v-if="activeMenu === ''">
                    <div class="avatar__menu-list-item" @click="activeMenu = 'appearance'">
                        <div class="avatar__menu-list-item__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
                                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"/>
                            </svg>
                        </div>
                        {{ __('account.profile.avatar.appearance') }}
                    </div>
                    <div class="avatar__menu-list-item" @click="activeMenu = 'style'">
                        <div class="avatar__menu-list-item__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 473.001 473" xml:space="preserve">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M451.426,315.003c-0.517-0.344-1.855-0.641-2.41-0.889l-201.09-88.884v-28.879c38.25-4.6,57.136-29.835,57.136-62.28 c0-35.926-25.283-63.026-59.345-63.026c-35.763,0-65.771,29.481-65.771,64.384c0,6.005,4.973,10.882,10.978,10.882 c1.788,0,3.452-0.535,4.934-1.291c3.519-1.808,6.024-5.365,6.024-9.591c0-22.702,20.674-42.62,44.217-42.62 c22.003,0,37.982,17.356,37.982,41.262c0,23.523-19.011,41.262-44.925,41.262c-6.005,0-10.356,4.877-10.356,10.882v21.267v21.353 c0,0.21-0.421,0.383-0.401,0.593L35.61,320.55C7.181,330.792-2.554,354.095,0.554,371.881 c3.194,18.293,18.704,30.074,38.795,30.074H422.26c23.782,0,42.438-12.307,48.683-32.942 C477.11,348.683,469.078,326.766,451.426,315.003z M450.115,364.031c-3.452,11.427-13.607,18.8-27.846,18.8H39.349 c-9.725,0-16.104-5.394-17.5-13.368c-1.587-9.104,4.265-22.032,21.831-28.42l199.531-94.583l196.844,87.65 C449.303,340.717,453.434,353.072,450.115,364.031z"></path> </g> </g>
                            </svg>
                        </div>
                        {{ __('account.profile.avatar.style') }}
                    </div>
                    <div class="avatar__menu-list-item" @click="activeMenu = 'background'">
                        <div class="avatar__menu-list-item__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-app" viewBox="0 0 16 16">
                                <path d="M11 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6zM5 1a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4H5z"/>
                            </svg>
                        </div>
                        {{ __('account.profile.avatar.background') }}
                    </div>
                </div>
                <div class="avatar__menu-list__group" v-if="activeMenu === 'appearance'">
                    <div class="avatar__menu-list__group-item" @click="activeMenu = 'skins'">
                        <svg width="1.5rem" height="1.5rem" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" stroke-width="3" stroke="#000000" fill="none">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><circle cx="32" cy="18.14" r="11.14"></circle><path d="M54.55,56.85A22.55,22.55,0,0,0,32,34.3h0A22.55,22.55,0,0,0,9.45,56.85Z"></path></g>
                        </svg>
                        {{ __('account.profile.avatar.skin') }}
                    </div>
                    <div class="avatar__menu-list__group-item" @click="activeMenu = 'eyes'">
                        <svg width="1.5rem" height="1.5rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2.68936 6.70456C2.52619 6.32384 2.08528 6.14747 1.70456 6.31064C1.32384 6.47381 1.14747 6.91472 1.31064 7.29544L2.68936 6.70456ZM15.5872 13.3287L15.3125 12.6308L15.5872 13.3287ZM9.04145 13.7377C9.26736 13.3906 9.16904 12.926 8.82185 12.7001C8.47466 12.4742 8.01008 12.5725 7.78417 12.9197L9.04145 13.7377ZM6.37136 15.091C6.14545 15.4381 6.24377 15.9027 6.59096 16.1286C6.93815 16.3545 7.40273 16.2562 7.62864 15.909L6.37136 15.091ZM22.6894 7.29544C22.8525 6.91472 22.6762 6.47381 22.2954 6.31064C21.9147 6.14747 21.4738 6.32384 21.3106 6.70456L22.6894 7.29544ZM19 11.1288L18.4867 10.582V10.582L19 11.1288ZM19.9697 13.1592C20.2626 13.4521 20.7374 13.4521 21.0303 13.1592C21.3232 12.8663 21.3232 12.3914 21.0303 12.0985L19.9697 13.1592ZM11.25 16.5C11.25 16.9142 11.5858 17.25 12 17.25C12.4142 17.25 12.75 16.9142 12.75 16.5H11.25ZM16.3714 15.909C16.5973 16.2562 17.0619 16.3545 17.409 16.1286C17.7562 15.9027 17.8545 15.4381 17.6286 15.091L16.3714 15.909ZM5.53033 11.6592C5.82322 11.3663 5.82322 10.8914 5.53033 10.5985C5.23744 10.3056 4.76256 10.3056 4.46967 10.5985L5.53033 11.6592ZM2.96967 12.0985C2.67678 12.3914 2.67678 12.8663 2.96967 13.1592C3.26256 13.4521 3.73744 13.4521 4.03033 13.1592L2.96967 12.0985ZM12 13.25C8.77611 13.25 6.46133 11.6446 4.9246 9.98966C4.15645 9.16243 3.59325 8.33284 3.22259 7.71014C3.03769 7.3995 2.90187 7.14232 2.8134 6.96537C2.76919 6.87696 2.73689 6.80875 2.71627 6.76411C2.70597 6.7418 2.69859 6.7254 2.69411 6.71533C2.69187 6.7103 2.69036 6.70684 2.68957 6.70503C2.68917 6.70413 2.68896 6.70363 2.68892 6.70355C2.68891 6.70351 2.68893 6.70357 2.68901 6.70374C2.68904 6.70382 2.68913 6.70403 2.68915 6.70407C2.68925 6.7043 2.68936 6.70456 2 7C1.31064 7.29544 1.31077 7.29575 1.31092 7.29609C1.31098 7.29624 1.31114 7.2966 1.31127 7.2969C1.31152 7.29749 1.31183 7.2982 1.31218 7.299C1.31287 7.30062 1.31376 7.30266 1.31483 7.30512C1.31698 7.31003 1.31988 7.31662 1.32353 7.32483C1.33083 7.34125 1.34115 7.36415 1.35453 7.39311C1.38127 7.45102 1.42026 7.5332 1.47176 7.63619C1.57469 7.84206 1.72794 8.13175 1.93366 8.47736C2.34425 9.16716 2.96855 10.0876 3.8254 11.0103C5.53867 12.8554 8.22389 14.75 12 14.75V13.25ZM15.3125 12.6308C14.3421 13.0128 13.2417 13.25 12 13.25V14.75C13.4382 14.75 14.7246 14.4742 15.8619 14.0266L15.3125 12.6308ZM7.78417 12.9197L6.37136 15.091L7.62864 15.909L9.04145 13.7377L7.78417 12.9197ZM22 7C21.3106 6.70456 21.3107 6.70441 21.3108 6.70427C21.3108 6.70423 21.3108 6.7041 21.3109 6.70402C21.3109 6.70388 21.311 6.70376 21.311 6.70368C21.3111 6.70352 21.3111 6.70349 21.3111 6.7036C21.311 6.7038 21.3107 6.70452 21.3101 6.70576C21.309 6.70823 21.307 6.71275 21.3041 6.71924C21.2983 6.73223 21.2889 6.75309 21.2758 6.78125C21.2495 6.83757 21.2086 6.92295 21.1526 7.03267C21.0406 7.25227 20.869 7.56831 20.6354 7.9432C20.1669 8.69516 19.4563 9.67197 18.4867 10.582L19.5133 11.6757C20.6023 10.6535 21.3917 9.56587 21.9085 8.73646C22.1676 8.32068 22.36 7.9668 22.4889 7.71415C22.5533 7.58775 22.602 7.48643 22.6353 7.41507C22.6519 7.37939 22.6647 7.35118 22.6737 7.33104C22.6782 7.32097 22.6818 7.31292 22.6844 7.30696C22.6857 7.30398 22.6867 7.30153 22.6876 7.2996C22.688 7.29864 22.6883 7.29781 22.6886 7.29712C22.6888 7.29677 22.6889 7.29646 22.689 7.29618C22.6891 7.29604 22.6892 7.29585 22.6892 7.29578C22.6893 7.29561 22.6894 7.29544 22 7ZM18.4867 10.582C17.6277 11.3882 16.5739 12.1343 15.3125 12.6308L15.8619 14.0266C17.3355 13.4466 18.5466 12.583 19.5133 11.6757L18.4867 10.582ZM18.4697 11.6592L19.9697 13.1592L21.0303 12.0985L19.5303 10.5985L18.4697 11.6592ZM11.25 14V16.5H12.75V14H11.25ZM14.9586 13.7377L16.3714 15.909L17.6286 15.091L16.2158 12.9197L14.9586 13.7377ZM4.46967 10.5985L2.96967 12.0985L4.03033 13.1592L5.53033 11.6592L4.46967 10.5985Z" fill="#000000"></path> </g>
                        </svg>
                        {{ __('account.profile.avatar.eyes') }}
                    </div>
                    <div class="avatar__menu-list__group-item" @click="activeMenu = 'eyebrows'">
                        <svg width="1.5rem" height="1.5rem" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>eyebrow_line</title> <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Part" transform="translate(-192.000000, 0.000000)"> <g id="eyebrow_line" transform="translate(192.000000, 0.000000)"> <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path> <path d="M7.65839,10.4478 C5.97582,10.8292 4.59689,11.4276 3.71006,12.1548 C3.22513,12.5525 3.04805,12.9509 3.00912,13.2717 C2.96903,13.602 3.06346,13.9463 3.28848,14.2505 C3.7336,14.8522 4.6879,15.2711 5.84877,14.7925 C8.54702,13.6799 13.8165,11.5325 19.4843,11.9603 C19.0818,11.6736 18.6237,11.4145 18.1143,11.1845 C14.9375,9.75047 11.015,9.68694 7.65839,10.4478 Z M18.9372,9.36167 C20.6395,10.1301 22.108,11.2831 22.8998,12.9158 C23.0681,13.2628 23.0219,13.6757 22.781,13.9769 C22.5401,14.278 22.1474,14.4138 21.772,14.3258 C15.8145,12.93 9.78907,15.3311 6.61118,16.6414 C4.618,17.4633 2.68113,16.7923 1.68066,15.44 C1.18289,14.7672 0.915929,13.9186 1.02369,13.0307 C1.1326,12.1333 1.6126,11.2884 2.44183,10.6083 C3.65763,9.6113 5.36699,8.91645 7.21626,8.49728 C10.9972,7.64025 15.3643,7.74879 18.9372,9.36167 Z" id="形状" fill="#09244B"> </path> </g> </g> </g> </g>
                        </svg>
                        {{ __('account.profile.avatar.eyebrows') }}
                    </div>
                    <div class="avatar__menu-list__group-item" @click="activeMenu = 'mouth'">
                        <svg width="1.5rem" height="1.5rem" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="48" height="48" fill="white" fill-opacity="0.01"></rect> <path d="M4 24C4 24 10 15 14 15C18 15 22 17 24 17C26 17 30 15 34 15C38 15 44 24 44 24C44 24 34 34 24 34C14 34 4 24 4 24Z" stroke="#000000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M4 24H44" stroke="#000000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> </g>
                        </svg>
                        {{ __('account.profile.avatar.mouth') }}
                    </div>
                    <div class="avatar__menu-list__group-item" @click="activeMenu = 'hair'">
                        <svg width="1.5rem" height="1.5rem" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="currentColor">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>hair_fill</title> <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Part" transform="translate(-336.000000, -48.000000)" fill-rule="nonzero"> <g id="hair_fill" transform="translate(336.000000, 48.000000)"> <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path> <path d="M12,3 C7.02944,3 3,7.02944 3,12 L3,18 C3,19.6569 4.34315,21 6,21 L7.38197,21 C8.13951,21 8.83204,20.572 9.17082,19.8944 L9.34564,19.5448 C9.03131,19.3254 8.72677,19.0709 8.44209,18.7842 C7.34335,17.6778 6.5,16.0546 6.5,14 C6.5,13.265 6.62409,12.5336 6.84885,11.8426 C6.94857,11.536 7.22583,11.5 7.5,11.5 C9.19063,11.5 10.6854,10.6614 11.5912,9.3752 C11.6848,9.24221 11.8373,9.16308 12,9.16309 C12.1626,9.16309 12.3151,9.24221 12.4088,9.37521 C13.3145,10.6614 14.8093,11.5 16.5,11.5 C16.7742,11.5 17.0515,11.536 17.1512,11.8426 C17.3759,12.5337 17.5,13.265 17.5,14 C17.5,16.0546 16.6567,17.6778 15.5579,18.7842 C15.2732,19.0709 14.9687,19.3254 14.6544,19.5448 L14.8292,19.8944 C15.168,20.572 15.8605,21 16.618,21 L18,21 C19.6569,21 21,19.6569 21,18 L21,12 C21,7.02944 16.9706,3 12,3 Z" id="路径" fill="#000000"> </path> </g> </g> </g> </g></svg>
                        {{ __('account.profile.avatar.hair') }}
                    </div>
                    <div class="avatar__menu-list__group-item" @click="activeMenu = 'tattoos'">
                        <svg width="1.5rem" height="1.5rem" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 16.657A8.962 8.962 0 0 1 3 11c0-4.97 4.03-8 9-8s9 3.03 9 8c0 2.143-.75 4.112-2 5.657m-14 0V19a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2.343m-14 0h1.5m12.5 0h-1.5"></path><circle cx="8" cy="12" r="1" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></circle><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m11 16 1-2 1 2h-2zm-2 3v2m3-2v2m3-2v2"></path><circle cx="16" cy="12" r="1" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></circle></g>
                        </svg>
                        {{ __('account.profile.avatar.tattoos') }}
                    </div>
                </div>
                <div class="avatar__menu-list__group" v-if="activeMenu === 'style'">
                    <div class="avatar__menu-list__group-item" @click="activeMenu = 'top'">
                        <svg width="1.5rem" height="1.5rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 7L6 4H9C9 4.39397 9.0776 4.78407 9.22836 5.14805C9.37913 5.51203 9.6001 5.84274 9.87868 6.12132C10.1573 6.3999 10.488 6.62087 10.8519 6.77164C11.2159 6.9224 11.606 7 12 7C12.394 7 12.7841 6.9224 13.1481 6.77164C13.512 6.62087 13.8427 6.3999 14.1213 6.12132C14.3999 5.84274 14.6209 5.51203 14.7716 5.14805C14.9224 4.78407 15 4.39397 15 4H18L21 7L20.5785 11.2152C20.542 11.5801 20.1382 11.7829 19.8237 11.5942L18 10.5V18C18 19.1046 17.1046 20 16 20H8C6.89543 20 6 19.1046 6 18V10.5L4.17629 11.5942C3.86184 11.7829 3.45801 11.5801 3.42152 11.2152L3 7Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g>
                        </svg>
                        {{ __('account.profile.avatar.top') }}
                    </div>
                    <div class="avatar__menu-list__group-item" @click="activeMenu = 'glasses'">
                        <svg width="1.5rem" height="1.5rem" fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M3,10C2.76,10 2.55,10.09 2.41,10.25C2.27,10.4 2.21,10.62 2.24,10.86L2.74,13.85C2.82,14.5 3.4,15 4,15H7C7.64,15 8.36,14.44 8.5,13.82L9.56,10.63C9.6,10.5 9.57,10.31 9.5,10.19C9.39,10.07 9.22,10 9,10H3M7,17H4C2.38,17 0.96,15.74 0.76,14.14L0.26,11.15C0.15,10.3 0.39,9.5 0.91,8.92C1.43,8.34 2.19,8 3,8H9C9.83,8 10.58,8.35 11.06,8.96C11.17,9.11 11.27,9.27 11.35,9.45C11.78,9.36 12.22,9.36 12.64,9.45C12.72,9.27 12.82,9.11 12.94,8.96C13.41,8.35 14.16,8 15,8H21C21.81,8 22.57,8.34 23.09,8.92C23.6,9.5 23.84,10.3 23.74,11.11L23.23,14.18C23.04,15.74 21.61,17 20,17H17C15.44,17 13.92,15.81 13.54,14.3L12.64,11.59C12.26,11.31 11.73,11.31 11.35,11.59L10.43,14.37C10.07,15.82 8.56,17 7,17M15,10C14.78,10 14.61,10.07 14.5,10.19C14.42,10.31 14.4,10.5 14.45,10.7L15.46,13.75C15.64,14.44 16.36,15 17,15H20C20.59,15 21.18,14.5 21.25,13.89L21.76,10.82C21.79,10.62 21.73,10.4 21.59,10.25C21.45,10.09 21.24,10 21,10H15Z"></path></g>
                        </svg>
                        {{ __('account.profile.avatar.glasses') }}
                    </div>
                    <div class="avatar__menu-list__group-item" @click="activeMenu = 'accessories'">
                        <svg width="1.5rem" height="1.5rem" fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 501.334 501.334" xml:space="preserve">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M496.313,272c-10.667-37.333-39.467-59.733-64-68.267c-18.133-6.4-39.467-5.333-59.733,4.267V61.867 c0-11.733-9.6-21.333-21.333-21.333s-21.333,9.6-21.333,21.333V208c-14.933-7.467-29.867-9.6-43.733-8.533 c-13.867-24.533-35.2-40.533-55.467-46.933c-18.133-6.4-39.467-5.333-59.733,4.267V21.333C170.98,9.6,161.38,0,149.646,0 s-21.333,9.6-21.333,21.333V156.8c-20.267-9.6-40.533-11.733-59.733-5.333C45.113,160,15.246,182.4,4.58,219.733 c-6.4,24.533-7.467,64,29.867,110.933c58.667,73.6,86.4,102.4,100.267,113.067c3.2,3.2,16,10.667,27.733,2.133 c10.667-7.467,29.867-25.6,67.2-70.4c2.133,2.133,3.2,5.333,5.333,7.467c57.6,72.533,85.333,101.333,100.267,112 c3.2,3.2,7.467,6.4,11.733,6.4c1.067,0,6.4,0,7.467,0c4.267-1.067,7.467-3.2,10.667-5.333c13.867-10.667,41.6-38.4,100.267-112 C503.78,336,503.78,296.533,496.313,272z M232.847,304c-25.6,34.133-64,77.867-82.133,98.133c-19.2-19.2-56.533-64-83.2-97.067 c-21.333-26.667-28.8-52.267-22.4-73.6c6.4-20.267,23.467-34.133,38.4-39.467c12.8-5.333,30.933,2.133,48,18.133 c1.067,1.067,2.133,2.133,3.2,3.2c8.533,8.533,20.267,8.533,27.733,1.067c0,0,0,0,1.067-1.067c0,0,1.067,0,1.067-1.067 c18.133-18.133,38.4-26.667,52.267-21.333c14.933,4.267,32,19.2,38.4,39.467C261.647,252.8,254.18,277.333,232.847,304z M434.447,356.267c-25.6,33.067-64,76.8-83.2,97.067c-18.133-19.2-57.6-65.067-83.2-98.133c-4.267-5.333-7.467-9.6-10.667-14.933 c2.133-3.2,4.267-5.333,7.467-8.533c28.8-35.2,35.2-67.2,33.067-90.667c10.667,2.133,22.4,8.533,35.2,19.2 c1.067,1.067,2.133,2.133,3.2,3.2c8.533,8.533,20.267,8.533,27.733,1.067c0,0,0,0,1.067-1.067c0,0,1.067,0,1.067-1.067 c18.133-18.133,38.4-26.667,52.267-21.333c14.933,4.267,32,19.2,38.4,39.467C463.247,305.067,455.78,329.6,434.447,356.267z"></path> </g> </g> </g>
                        </svg>
                        {{ __('account.profile.avatar.accessories') }}
                    </div>
                </div>
                <div class="avatar__menu-items" v-if="!['', 'appearance', 'style'].includes(activeMenu)">
                    <div class="avatar__menu-items__group-list"
                         v-if="activeMenu === 'skins'"
                    >
                        <div
                            v-for="skin in skins"
                            class="avatar__menu-item"
                            :class="activeSkin === skin ? 'active' : ''"
                            :style="'background-color: #' + skin + ';'"
                            @click="updateAvatar('skin', skin)"
                        />
                    </div>
                    <div class="avatar__menu-items__group-list"
                         v-if="activeMenu === 'eyes'"
                    >
                        <div
                            v-for="eye in eyes"
                            class="avatar__menu-item"
                            :class="activeEyes === eye ? 'active' : ''"
                            :style="'background-color: #' + activeSkin + ';'"
                            @click="updateAvatar('eyes', eye)"
                        >
                            <avatar-eyes
                                :eyes="eye"
                            />
                        </div>
                    </div>
                    <div class="avatar__menu-items__group-list"
                         v-if="activeMenu === 'mouth'"
                    >
                        <div
                            v-for="mouth in mouths"
                            class="avatar__menu-item"
                            :class="activeMouth === mouth ? 'active' : ''"
                            :style="'background-color: #' + activeSkin + ';'"
                            @click="updateAvatar('mouth', mouth)"
                        >
                            <avatar-mouth
                                :mouth="mouth"
                            />
                        </div>
                    </div>
                    <div class="avatar__menu-items__group"
                         v-if="activeMenu === 'hair'"
                    >
                        <div class="avatar__menu-items__group-list">
                            <div
                                v-for="hairStyle in hairstyles"
                                class="avatar__menu-item"
                                :class="activeHairstyle === hairStyle ? 'active' : ''"
                                @click="updateAvatar('hairstyle', hairStyle)"
                            >
                                <avatar-hair-back
                                    :hair="hairStyle"
                                    :color="hairColorFront(activeHaircolor)"
                                />
                                <avatar-hair-front
                                    :hair="hairStyle"
                                    :color="hairColorBack(activeHaircolor)"
                                />
                            </div>
                        </div>
                        <span>{{ __('account.profile.avatar.facial_hair') }}</span>
                        <div class="avatar__menu-items__group-list">
                            <div
                                v-for="facialhair in facialhairs"
                                class="avatar__menu-item"
                                :class="activeFacialhair === facialhair ? 'active' : ''"
                                @click="updateAvatar('facialhair', facialhair)"
                            >
                                <avatar-facial-hair
                                    :facial-hair="facialhair"
                                    :color="hairColorFacial(activeHaircolor)"
                                />
                            </div>
                        </div>
                        <span>{{ __('account.profile.avatar.color') }}</span>
                        <div class="avatar__menu-items__group-list">
                            <div
                                v-for="haircolor in haircolors"
                                class="avatar__menu-item"
                                :class="activeHaircolor === haircolor ? 'active' : ''"
                                :style="'background-color: #' + hairColorFront(haircolor) + ';'"
                                @click="updateAvatar('haircolor', haircolor)"
                            >
                            </div>
                        </div>
                    </div>
                    <div class="avatar__menu-items__group-list"
                         v-if="activeMenu === 'accessories'"
                    >
                        <div
                            v-for="accessory in accessories"
                            class="avatar__menu-item"
                            :class="activeAccessories === accessory ? 'active' : ''"
                            @click="updateAvatar('accessories', accessory)"
                        >
                            <avatar-accessories
                                :accessory="accessory"
                            />
                        </div>
                    </div>
                    <div class="avatar__menu-items__group-list"
                         v-if="activeMenu === 'eyebrows'"
                    >
                        <div
                            v-for="eyebrow in eyebrows"
                            class="avatar__menu-item"
                            :class="activeEyebrows === eyebrow ? 'active' : ''"
                            :style="'background-color: #' + activeSkin + ';'"
                            @click="updateAvatar('eyebrows', eyebrow)"
                        >
                            <avatar-eyebrows
                                :eyebrows="eyebrow"
                            />
                        </div>
                    </div>
                    <div class="avatar__menu-items__group"
                         v-if="activeMenu === 'glasses'"
                    >
                        <div class="avatar__menu-items__group-list">
                            <div
                                v-for="glass in glasses"
                                class="avatar__menu-item"
                                :class="activeGlasses === glass ? 'active' : ''"
                                @click="updateAvatar('glasses', glass)"
                            >
                                <avatar-glasses
                                    :glasses="glass"
                                    :opacity="activeGlassopacity"
                                />
                            </div>
                        </div>
                        <span>{{ __('account.profile.avatar.opacity') }}</span>
                        <div class="avatar__menu-items__group-list">
                            <div
                                v-for="opacity in glassopacities"
                                class="avatar__menu-item text"
                                :class="activeGlassopacity * 100 === opacity ? 'active' : ''"
                                @click="updateAvatar('glassopacity', opacity / 100)"
                            >
                                {{ opacity }}%
                            </div>
                        </div>
                    </div>
                    <div class="avatar__menu-items__group"
                         v-if="activeMenu === 'top'"
                    >
                        <div class="avatar__menu-items__group-list">
                            <div
                                v-for="cloth in clothes"
                                class="avatar__menu-item"
                                :class="activeClothes === cloth ? 'active' : ''"
                                @click="updateAvatar('clothes', cloth)"
                            >
                                <avatar-clothes
                                    :clothes="cloth"
                                />
                            </div>
                        </div>
                        <span>{{ __('account.profile.avatar.color') }}</span>
                        <div class="avatar__menu-items__group-list">
                            <div
                                v-for="fabricColor in fabriccolors"
                                class="avatar__menu-item"
                                :class="activeFabriccolor === fabricColor ? 'active' : ''"
                                :style="'background-color: #' + fabricColor + ';'"
                                @click="updateAvatar('fabriccolor', fabricColor)"
                            >
                            </div>
                        </div>
                    </div>
                    <div class="avatar__menu-items__group-list"
                         v-if="activeMenu === 'tattoos'"
                    >
                        <div
                            v-for="tattoo in tattoos"
                            class="avatar__menu-item"
                            :class="activeTatttoos === tattoo ? 'active' : ''"
                            @click="updateAvatar('tattoos', tattoo)"
                        >
                            <avatar-tattoos
                                :tattoos="tattoo"
                            />
                        </div>
                    </div>
                    <div class="avatar__menu-items__group-list"
                         v-if="activeMenu === 'background'"
                    >
                        <div
                            v-for="background in backgrounds"
                            v-if="hasPart('backgrounds', background)"
                            class="avatar__menu-item"
                            :class="activeBackground === background.name ? 'active' : ''"
                            :style="'background: ' + (background.type === 'color' ? '#' + background.colorCode + ';' : '') + (background.type === 'image' ? 'url(\'' + background.fileUrl + '\'); background-size: cover;' : '')"
                            @click="updateAvatar('background', background.name)"
                        >
                        </div>
                    </div>
                </div>
            </div>
            <div class="avatar__component col-12 col-lg-6">
                <avatar-component
                    ref="avatarComponent"
                    @loaded="setDefaultData"
                />
            </div>
        </div>
        <div class="mt-3">
            <b-overlay
                :show="saving"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
                class="d-inline-block"
            >
            <button type="submit" class="btn btn-primary" :disabled="saving" @click="save">
                {{ __('account.profile.save') }}
            </button>
            </b-overlay>
        </div>
    </div>
</template>

<style scoped>

</style>
